import { Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Base } from "../../../components/RootLayout";
import * as PageRoutes from "./../../../utils/route_pages";
import { useEffect } from "react";

const ListBank = (props) => {
  const { isWebview = true, onClick = () => {}, getAllBanks, dataBank } = props;
  const navigate = useNavigate();

  useEffect(() => {
    getAllBanks();
  }, []);

  const RenderContent = (data) => {
    const { code, name, isStrong = false, onChange = () => {} } = data;
    return (
      <Row
        className={isStrong ? "font-bold" : ""}
        onClick={() => onChange(data)}
      >
        <Col className="p-1">{code}</Col>
        <Col>{name}</Col>
      </Row>
    );
  };

  const onChange = (data) => {
    const { code, name } = data;
    if (isWebview) {
      navigate({
        pathname: PageRoutes.listBank,
        search: `?code=${code}&name=${name}`,
      });
    } else {
      onClick({ code, name });
    }
  };

  return (
    <Base>
      <Container className={`mt-${isWebview ? "xl-5" : 3}`}>
        <RenderContent code="Code" name="Bank Name" isStrong />
        {dataBank &&
          dataBank.map((data) => {
            return (
              <RenderContent
                key={data.code}
                code={data.code}
                name={data.name}
                onChange={(val) => onChange(val)}
              />
            );
          })}
      </Container>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  reward_dashboard: state.RewardSM.reward_dashboard,
  listBank: state.RewardSM.listBank,
  dataBank: state.RewardSM.dataBank,
});

const mapDispatchToProps = (dispatch) => ({
  getAllBanks: dispatch.RewardSM.getAllBanks,
});

export default connect(mapStateToProps, mapDispatchToProps)(ListBank);
